import React, { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
import './index.scss';
import Exit from '../Exit';
import SpeedBtn from '../SpeedBtn';
import DialGauge from './DialGauge';

//music
import launchMp3 from '../../music/launch.mp3';
import steadyMp3 from '../../music/steady.mp3';
import speedUpMp3 from '../../music/speedUp.mp3';
import speedSteadyMp3 from '../../music/speedSteady.mp3';
import speedDownMp3 from '../../music/speedDown.mp3';

const musics = [{
  value: 'launch',
  src: launchMp3
}, {
  value: 'steady',
  src: steadyMp3
}, {
  value: 'speedUp',
  src: speedUpMp3
}, {
  value: 'speedSteady',
  src: speedSteadyMp3
}, {
  value: 'speedDown',
  src: speedDownMp3
}]
export default function Speed({ style, navVisible, movingSkybox, onSpeed, speedData, differ, entrySpeed }) {
  const [ status, setStatus ] = useState(0); // -1: 复原, 1: 加速, 0: 刹车, 9: moving
  const [ speedText, setSpeedText ] = useState('刹车');
  const [ disabled, setDisabled ] = useState(true);
  // const disabled = speedData.car1.speed > 0 && speedData.car1.speed > 100;
  const isSpeed = [0, 1].includes(status);

  const audioDoms = {};
  musics.forEach(m => {
    audioDoms[m.value] = useRef(null);
  });

  useEffect(() => {
    audioDoms.speedUp.current.play();
  }, [])

  useEffect(() => {
    // if (!movingSkybox) {
    // audioDoms.launch.current.pause();
    // audioDoms.steady.current.pause();
    // }
    if (status === 0 && speedData.car1.speed === 100) {
      if (differ) {
        if (speedData.car2.speed === 100) {
          audioDoms.speedUp.current.pause();
          audioDoms.speedSteady.current.play();
          setDisabled(false);
        }
      } else {
        audioDoms.speedUp.current.pause();
        audioDoms.speedSteady.current.play();
        setDisabled(false);
      }
    }
    if (status === 1 && speedData.car1.speed === 0) {
      if (differ && speedData.car2.speed === 0) {
        audioDoms.speedDown.current.pause();
        setDisabled(false);
      } else {
        audioDoms.speedDown.current.pause();
        setDisabled(false);
      }
    }
  })

  const handleSpeed = async () => {
    setDisabled(true);
    if (movingSkybox && status === -1) {
      await launchMusicPlay();
      onSpeed('moving', true);
      setSpeedText('加速');
      setStatus(9);
      setDisabled(false);
    } else {
      let _status = status;
      switch (_status) {
        case 9:
        case 1:
        case -1:
          speedUpMusicPlay();
          _status = 0;
          setSpeedText('刹车');
          break;
        default:
        setSpeedText('加速');
          speedDownMusicPlay();
          _status = 1;
          break;
      }
      setStatus(_status);
      onSpeed('speeder', { mode: _status, action: 1 });
    }
  }

  function launchMusicPlay() {
    return new Promise((r, j) => {
      audioDoms.launch.current.load();
      audioDoms.launch.current.play();
      audioDoms.steady.current.load();
      setTimeout(() => {
        audioDoms.launch.current.pause();
        audioDoms.steady.current.play();
        r();
      }, 2000);
    });
  }
  function speedUpMusicPlay() {
    return new Promise((r) => {
      audioDoms.steady.current.pause();

      audioDoms.speedUp.current.load();
      audioDoms.speedUp.current.play();

      audioDoms.speedSteady.current.load();
      audioDoms.speedUp.current.onended = () => {
        audioDoms.speedSteady.current.play();
        r();
      };
    })
  }
  function speedDownMusicPlay() {
    return new Promise((r) => {
      audioDoms.speedSteady.current.pause();

      audioDoms.speedDown.current.load();
      audioDoms.speedDown.current.play();
      audioDoms.speedUp.current.onended = () => {
        r();
      };
    })
  }

  return (
    <div className="speed-root" style={{...style}}>
      {isSpeed && 
      <Exit onClick={() => {
        onSpeed('speeder', { action: 0 });
        setStatus(-1);
        setSpeedText('启动');
        setDisabled(false);
        for (const k in audioDoms) {
          audioDoms[k].current.pause();
        }
      }}/>}
      <SpeedBtn
        text={speedText}
        {...{ disabled, navVisible, entrySpeed, handleSpeed }}
      >
      </SpeedBtn>
       {isSpeed &&
        <div className={classnames("dial-gauge-container", { differ })}>
          <DialGauge 
            speed={speedData.car1.speed}
            time={speedData.car1.time}
            distance={speedData.car1.distance}
          />
          {differ &&
          <DialGauge 
            speed={speedData.car2.speed}
            time={speedData.car2.time}
            distance={speedData.car2.distance}
          />}
        </div>}

      {musics.map(music => 
        <audio
          key={music.value}
          ref={audioDoms[music.value]}
          style={{display: 'none'}}
          height="0"
          width="0"
          src={music.src}
          loop={music.value.indexOf('teady') > -1}
        />
      )}
    </div>
  )
}